/**
 * 获取图片的 crop 对象 x,y,width,height 百分比
 * 1. 获取图片真实像素
 * 2. 根据图片真实像素和是否传入指定裁切框宽高算出裁切框 crop x,y,width,height 百分比
 */
import { removeSuffix } from '@hlj/hlj-utils'

const getClipUrl = (url, { width, height, x, y }) => {
  const cropSuffix = `imageMogr2/crop/!${width}x${height}a${x}a${y}`

  return `${removeSuffix(url)}?${cropSuffix}`
}

export const getCropData = (url, info, aspect) => {
  let _w = info.width
  let _h = info.height
  let orientationFlag = false
  if (info.orientation) {
    // 纠正图片方向
    const orientationVal = info.orientation.val || ''
    if (/(Left)|(Right)/.test(orientationVal)) {
      orientationFlag = true
      ;[_w, _h] = [_h, _w]
    }
  }
  const infoWidth = Number(_w)
  const infoHeight = Number(_h)
  let width = 0
  let height = 0
  let x = 0
  let y = 0
  function getHengTu() {
    width = Math.ceil(infoHeight * aspect)
    height = infoHeight
    x = (infoWidth - width) / 2
    y = 0
  }
  function getShuTu() {
    width = infoWidth
    height = Math.ceil(infoWidth / aspect)
    x = 0
    y = (infoHeight - height) / 2
  }
  // 横图
  if (infoWidth > infoHeight) {
    getHengTu()
    if (x < 0) {
      getShuTu()
    }
  } else {
    getShuTu()
    if (y < 0) {
      getHengTu()
    }
  }

  const pixel = {
    x,
    y,
    width,
    height
  }
  // 图片的宽高纠正目前放在具体使用位置处理
  info.width = orientationFlag ? height : width
  info.height = orientationFlag ? width : height
  return {
    clipUrl: getClipUrl(url, pixel),
    pixel
  }
}
